import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { ROUTES } from "~/const/route";
import {
  NoAuthSpecialist,
  AuthSpecialist,
  NoAuthAdmin,
  AuthAdmin,
} from "~/middlewares/auth";

// 専門家向けページ
import { SpecialistLogin } from "~/screens/specialist/login";
import { SpecialistRegistor } from "~/screens/specialist/registor";
import { SpecialistLogout } from "~/screens/specialist/logout";
import { SpecialistHome } from "~/screens/specialist/home";
import { SpecialistFinish } from "~/screens/specialist/finish";

// 運営会社向けページ
import { AdminLogin } from "~/screens/admin/login";
import { AdminLogout } from "~/screens/admin/logout";
// import { AdminHome } from "~/screens/admin/home";
import { AdminSpecialist } from "~/screens/admin/specialist";
import { AdminTalkPattern } from "~/screens/admin/pattern";
import { AdminNotification } from "~/screens/admin/notification";
import { AdminHelp } from "~/screens/admin/help";

const Router: React.VFC = () => {
  return (
    <BrowserRouter>
      <Switch>
        {/* 専門家 */}
        <NoAuthSpecialist
          path={ROUTES.SPECIALIST.LOGIN}
          component={SpecialistLogin}
        />
        <NoAuthSpecialist
          path={ROUTES.SPECIALIST.REGISTOR}
          component={SpecialistRegistor}
        />
        <NoAuthSpecialist
          path={ROUTES.SPECIALIST.LOGOUT}
          component={SpecialistLogout}
        />
        <AuthSpecialist
          path={ROUTES.SPECIALIST.HOME}
          component={SpecialistHome}
        />
        <AuthSpecialist
          path={ROUTES.SPECIALIST.FINISH}
          component={SpecialistFinish}
        />

        {/* 運営会社 */}
        <NoAuthAdmin path={ROUTES.ADMIN.LOGIN} component={AdminLogin} />
        <NoAuthAdmin path={ROUTES.ADMIN.LOGOUT} component={AdminLogout} />
        {/* <AuthAdmin path={ROUTES.ADMIN.HOME} component={AdminHome} /> */}
        <AuthAdmin path={ROUTES.ADMIN.SPECIALIST} component={AdminSpecialist} />
        <AuthAdmin path={ROUTES.ADMIN.PATTERN} component={AdminTalkPattern} />
        <AuthAdmin
          path={ROUTES.ADMIN.NOTIFICATION}
          component={AdminNotification}
        />
        <AuthAdmin path={ROUTES.ADMIN.HELP} component={AdminHelp} />

        {/* Not Found */}
        <Route
          path={ROUTES.SPECIALIST.ROOT}
          component={() => <Redirect to={ROUTES.SPECIALIST.LOGIN} />}
        />
        <Route
          path={ROUTES.ADMIN.ROOT}
          component={() => <Redirect to={ROUTES.ADMIN.LOGIN} />}
        />
        <Route component={() => <Redirect to={ROUTES.SPECIALIST.LOGIN} />} />
      </Switch>
    </BrowserRouter>
  );
};

export default Router;
